module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABNUlEQVQ4T83TMUsDQRCG4XfmLAQVrSTYC4I2gmAhxrtYKIFAOgv9AdqKpYVgKRZCmjSCICnSBbE0lxjSW1jZ+B+UgIg3KwlEMZ6BC1c41Tb78O3MjpBSSUoO6UIhZN7hdQs6oybsJWqolsW5hY5zhTy8jIL1oBpMzYjUAC8Oa8LyGzwNS/zVo7+wOyiMqVYc3DTM9k7A4hL/aPYgNgFFVEvO7BjVQwfXQfccU7+m1secyByQMbPdHNyGsKSq95gdbcDloBU7/i42LXJlzp3noN2/FMK2qlY/zIqbUK/DoqgGgVkp8T9qwAGqp2a2Jp634sF+NorWE0PddE3VM6AocGEiO/6oUBW8WdUKkEfkITHUgtVItQwoMC4i8w5afhRlEz0thEnAF7531MFzAI+JoGGr8/+gTydgbBP65o0tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu_icons/xiadie_image.png
// module id = f3IH
// module chunks = 0